import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
	Drawer,
	Icon,
	AppBar,
	Toolbar,
	IconButton,
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
} from '@material-ui/core';
import {
	ChevronRight, Home, Assessment,
	Person, Assignment, ExitToApp,
	DateRange, AttachMoney, ChatBubble,
} from '@material-ui/icons';

// Theme
import darkTheme from '../../config/themes/mainmenu';
import grey from '@material-ui/core/colors/grey';
import primary from '../../config/colors/app-primary';


const drawerWidth = 240;

const styles = theme => ({
	drawerPaper: {
		position: 'relative',
		whiteSpace: 'nowrap',
		height: '100%',
		width: drawerWidth,
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
		overflowX: 'hidden',
		overflowY: 'auto',
	},
	drawerPaperClose: {
		width: 56,
		overflowX: 'hidden',
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	drawerInner: {
		// Make the items inside not wrap when transitioning:
		width: drawerWidth,
	},
	drawerHeader: {
		display: 'flex',
		alignItems: 'right',
		justifyContent: 'center',
		color: '#ffffff',
		background: theme.palette.primary[300],
		position: 'relative',
		width: '100%',
		//borderBottom: '3px solid' + theme.palette.primary[200],
	},
	list: {
		width: '100%',
		maxWidth: drawerWidth-1,
		background: theme.palette.background.paper,
	},
	active: {
		background: `linear-gradient(to right, ${grey[700]} 98%,${primary[200]} 98%,${primary[200]} 100%)`,
	},
	link: {
		textDecoration: 'none',
	},
	toggleShift: {
		marginLeft: -20,
	},
});



class UnthemedMenu extends React.PureComponent {
	render() {
		const {permissions, classes, selectedItem: selected} = this.props;

		return (
			<Drawer
				variant="permanent"
				classes={{
					paper: classNames(classes.drawerPaper, !this.props.isOpen && classes.drawerPaperClose),
				}}
				open={this.props.isOpen}
			>
				<div className={classes.drawerInner}>
					<AppBar className={classes.drawerHeader}>
						<Toolbar>
							<IconButton
								onClick={this.props.toggle}
								className={classes.toggleShift}
							>
								<Icon><ChevronRight /></Icon>
							</IconButton>

						</Toolbar>
					</AppBar>
					<List>
						<Link to="/" className={classes.link} >
							<ListItem button className={(!selected || selected === '/') ? classes.active : ''}>
								<ListItemIcon>
									<Home />
								</ListItemIcon>
								<ListItemText inset primary="Home" />
							</ListItem>
						</Link>
						<Link to="/businesspartners" className={classes.link} >
							<ListItem button className={selected === 'businesspartners' ? classes.active : ''}>
								<ListItemIcon>
									<Person />
								</ListItemIcon>
								<ListItemText inset primary="Business Partners" />
							</ListItem>
						</Link>
						{permissions.accounting &&
						<Link to="/accounting" className={classes.link}>
							<ListItem button className={selected === 'accounting' ? classes.active : ''}>
								<ListItemIcon>
									<AttachMoney/>
								</ListItemIcon>
								<ListItemText inset primary="Accounting"/>
							</ListItem>
						</Link>
						}
						<Link to="/salesorders" className={classes.link} >
							<ListItem button className={selected === 'salesorders' ? classes.active : ''}>
								<ListItemIcon>
									<Assignment />
								</ListItemIcon>
								<ListItemText inset primary="Sales Orders" />
							</ListItem>
						</Link>
						<Link to="/reports" className={classes.link} >
							<ListItem button className={selected === 'reports' ? classes.active : ''}>
								<ListItemIcon>
									<Assessment />
								</ListItemIcon>
								<ListItemText inset primary="Reports" />
							</ListItem>
						</Link>
						<a href="https://sales.gppinc.com/calendar" target="_blank" className={classes.link} rel="noopener noreferrer">
							<ListItem button className={selected === 'calendar' ? classes.active : ''}>
								<ListItemIcon>
									<DateRange />
								</ListItemIcon>
								<ListItemText inset primary="Activity Calendar" />
							</ListItem>
						</a>
						{permissions.broadcast &&
						<Link to="/broadcast" className={classes.link} >
							<ListItem button className={selected === 'broadcast' ? classes.active : ''}>
								<ListItemIcon>
									<ChatBubble />
								</ListItemIcon>
								<ListItemText inset primary="Broadcast" />
							</ListItem>
						</Link>
						}
						<Link to="/logout" className={classes.link} >
							<ListItem button className={selected === 'logout' ? classes.active : ''}>
								<ListItemIcon>
									<ExitToApp />
								</ListItemIcon>
								<ListItemText inset primary="Log Out" />
							</ListItem>
						</Link>
					</List>
				</div>
			</Drawer>
		);
	}
}


UnthemedMenu.defaultProps = {
	isOpen: false,
	activeElement: 'none',
};

UnthemedMenu.propTypes = {
	classes: PropTypes.object.isRequired,
	isOpen: PropTypes.bool.isRequired,
	activeElement: PropTypes.string.isRequired,
	toggle: PropTypes.func.isRequired,
};

let MainMenu = (props) => (
	<MuiThemeProvider theme={darkTheme}>
		<UnthemedMenu {...props} />
	</MuiThemeProvider>
);
MainMenu = withStyles(styles)(MainMenu);


const mapStateToProps = state => {
	return {
		permissions: state.auth.permissions,
	};
};



export default connect(mapStateToProps)(MainMenu);

